import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl'

function ChoosePlanFooter(props) {
    return (<div className="row mb-4 border-top">
        <div className="flex flex-column mt-4 col-md-12">
            <div className="text-align-center">
                <div className="custom-lead mb-3">
                    <h3 className={'custom-lead'}>
                        <FormattedMessage
                            id="myaccount.choose_plan.companies_plan_message"
                            defaultMessage="Enterprises"
                        />
                    </h3>
                </div>
                <div className="flex flex-column">
                    <div>
                        <FormattedMessage
                            id="myaccount.choose_plan.companies_contact_us"
                            defaultMessage="More than 5 locations or users?"
                        />
                    </div>
                    <div>
                        <FormattedMessage
                            id="myaccount.choose_plan.companies_contact_us_p"
                            defaultMessage="{cu} for custom pricing."
                            values={{
                                cu: (<a href="#" className="link-primary underline" onClick={props.intercomMessage}>
                                    <FormattedMessage
                                        id="myaccount.choose_plan.companies_contact"
                                        defaultMessage="Contact us"

                                    />
                                </a>)
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>);
}

export default injectIntl(ChoosePlanFooter);


// WEBPACK FOOTER //
// ./src/my-account/chooseplanfooter.component.jsx